import React, { useState } from 'react';
import { Container, Box, Heading } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import { ArrowButton, DownloadAppModal } from '@hover/shared-components';
import { useMediaQuery } from '@chakra-ui/react';
import { navigate } from 'gatsby';
import { useABTesting } from '../../hooks';
import { ctaABTesting } from '../../utils/ctaABTesting';

interface Props {
  testId: string;
}

const RoofingCalculator: React.FC<Props> = ({ testId }) => {
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const [isDesktop] = useMediaQuery('(min-width: 1280px)');
  const abTestValue = useABTesting({ testName: `${testId}-cta-pressed` });

  if (!abTestValue) return <>Loading...</>;

  const toggleModal = () => {
    if (!isDesktop) setIsOpenModal(!isOpenModal);
    else if (abTestValue === 'A') {
      ctaABTesting('A');
      setIsOpenModal(!isOpenModal);
    } else {
      ctaABTesting('B');
      void navigate('/signup');
    }
  };

  return (
    <Container
      centerContent
      maxW="100%"
      px={{ base: 500, tablet: '56px' }}
      mb={{ base: 1000, desktop: 1100 }}
    >
      <Box
        bg="primary.100"
        maxW="1200px"
        w="100%"
        flexDir={{ base: 'column', desktop: 'row' }}
        px={{ base: 500, tablet: 1000 }}
        borderRadius="8px"
        alignItems="center"
        justifyContent="space-between"
        pt={{ base: 700, desktop: 500 }}
      >
        <DownloadAppModal isOpen={isOpenModal} onClose={toggleModal} />
        <Box
          flexDir="column"
          maxW={{ base: '100%', desktop: '480px' }}
          alignItems={{ base: 'center', desktop: 'flex-start' }}
          mb={{ base: 800, desktop: 0 }}
        >
          <Heading
            as="h2"
            textAlign={{ base: 'center', desktop: 'left' }}
            size={{ base: 500, tablet: 600 }}
            marginBottom={{ base: 500, tablet: 500 }}
          >
            HOVER roofing calculator
          </Heading>
          <Heading
            as="p"
            textAlign={{ base: 'center', desktop: 'left' }}
            size={300}
            marginBottom={700}
            isDisplay
          >
            The HOVER app keeps you off the roof and saves time. HOVER uses
            smartphone photos of any home to build an interactive 3D model with
            accurate exterior measurements (roof, siding, trim, etc.). Use the
            3D model to see different materials and colors on the home. Try
            HOVER today – pros’ first property is on us, and it’s free for
            homeowners!
          </Heading>
          <ArrowButton
            maxW={{ base: '100%', tablet: '233px' }}
            colorScheme="primary"
            variant="solid"
            onClick={toggleModal}
          >
            Download the App
          </ArrowButton>
        </Box>
        <StaticImage
          width={336}
          alt="Measure roof hand"
          src="../../assets/images/measure_roof_hand.png"
          placeholder="blurred"
        />
      </Box>
    </Container>
  );
};

export default RoofingCalculator;
